import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  standalone: false,
  name: 'bringozCustomDataDisplay'
})
export class BringozCustomDataDisplayPipe implements PipeTransform {
  transform(packageItems: any[], packageDynamicColumns: any): string {
    if (!packageItems) {
      packageItems = [];
    }

    let match: any = undefined;
    packageItems.forEach(item => {
      if (!!match) {
        return;
      }
      match = _.find(item.configuredFields || [], cf => cf.id === packageDynamicColumns.id || cf.packageFieldId === packageDynamicColumns.id || cf.fieldName === packageDynamicColumns.title);
    });

    return match?.value || '---';
  }
}
